import React from 'react';
import Button from './Button';
import { READING } from '../domain/reading';
import Unread from './Unread';
import ReadFailed from './ReadFailed';
import s from './EmptyState.module.css';

// The empty state, as a single reusable component.
//
// Every zero-state screen in MMS is the same four parts in the same order:
// illustration, headline, one line of explanation, one primary action. These
// screens are the onboarding: they teach a new studio what each section is
// for.
//
// The explainer says what the section gives you rather than restating the
// headline, as MMS's "Add your students so you can assign them repertoire,
// take their attendance, and more."
//
// `reading` is required (#629, #637): the answer `reading()` in
// src/domain/reading.js gives for the list. While it is `unread` the loading
// state is drawn instead, so a screen cannot claim "you have none" over a list
// its provider has not answered for; test/ui/reading.test.jsx refuses an
// `<EmptyState` written without it. While it is `failed` (#647), the failed
// state, with Try again, stands where the empty state would.
export default function EmptyState({
  reading,
  illustration,
  title,
  description,
  actionLabel,
  onAction,
  secondary = null,
}) {
  if (reading === READING.unread) return <Unread />;
  if (reading === READING.failed) return <ReadFailed />;
  return (
    <div className={s.empty}>
      {illustration ? <div className={s.art}>{illustration}</div> : null}
      <div className={s.title}>{title}</div>
      {description ? <div className={s.desc}>{description}</div> : null}
      {actionLabel || secondary ? (
        <div className={s.actions}>
          {actionLabel ? <Button variant="primary" onClick={onAction}>{actionLabel}</Button> : null}
          {secondary}
        </div>
      ) : null}
    </div>
  );
}
